import React, { FC } from 'react';

import {
  FormFieldsGradientRow,
  FormFieldsIdentitySection,
  FormFieldsSection,
  FormFieldsTitleStyleSection,
  FormFieldsUploadSection
} from '../components';

import {
  BG_COLOR_FIELDS,
  FONT_WEIGHT_OPTIONS,
  TITLE_DEFAULTS,
  UPLOAD_FIELDS
} from './TriggeredPopupFormFields.consts';

export const TriggeredPopupFormFields: FC = (): React.ReactElement => {
  return (
    <React.Fragment>
      <FormFieldsSection heading="Triggered Popup">
        <FormFieldsIdentitySection />
      </FormFieldsSection>

      <FormFieldsSection
        heading="Triggered Popup Design"
        description="Customize the Triggered Popup to fit your store theme."
        showSeparator
      >
        <FormFieldsGradientRow fields={BG_COLOR_FIELDS} layout="half" />
        <FormFieldsUploadSection fields={UPLOAD_FIELDS} />
      </FormFieldsSection>

      <FormFieldsTitleStyleSection
        heading="Title"
        nameField="title"
        colorField="fontColor"
        sizeField="fontSize"
        weightField="fontWeight"
        fontWeightOptions={FONT_WEIGHT_OPTIONS}
        defaults={TITLE_DEFAULTS}
        showSeparator
        separatorSpacing="lg"
        spacing="none"
      />
    </React.Fragment>
  );
};
